import React from 'react';
import * as S from './styles';
import Events from '../../Events';
import Aguas from '../../../front-novo/icons/Aguas.svg';
import Tronco from '../../../front-novo/icons/Tronco.svg';
import Barbatimao from '../../../front-novo/icons/Barbatimao.svg';
import Gaviao from '../../../front-novo/icons/Gaviao.svg';
import bordercardimg from '../../../front-novo/home/bordercardimg.png';
import { useHistory } from 'react-router-dom'; // Importando useHistory para a navegação

function Home2() {
  const history = useHistory(); // Criando uma função de navegação

  const handleNavigation = () => {
    history.push('/contato'); // Redireciona para a página /services
  };
  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <img src={Barbatimao} />

          <h1>ATENDIMENTO CLÍNICO</h1>
          <p>
            Ao entrar em contato com o Travessias pelo WhatsApp, você terá uma
            conversa inicial com um de nossos membros. A partir dessa conversa,
            indicaremos os profissionais mais adequados para atender às suas
            necessidades específicas.
          </p>
          <button onClick={handleNavigation}>Fale com a gente</button>
        </S.TextDiv>
      </S.Section>
    </S.Main>
  );
}

export default Home2;
